/** Matches the API's message when the bank has no published band set to score against. */
const NO_BAND_SET_ERROR = 'published band set';

export const getPublishErrorMessage = (error: unknown): string => {
  const message = (error as { message?: string } | undefined)?.message ?? '';

  if (message.includes(NO_BAND_SET_ERROR)) {
    return 'Your institution has no saved risk bands to score this template against. Go to Settings → Organization → Risk Bands to set them up, then publish again.';
  }

  return 'There was an issue publishing the template. Please contact support.';
};
